<div class="form-group">
    <div class="row">
        <div class="col">
            <label class="input-label">{{ 'Working days and hours' | translate }}</label>
            <div class="table-items">
                <div class="item item-header">
                    <div class="row">
                        <div class="col-3 align-items-center justify-content-start"></div>
                        <div class="col-1 align-items-center justify-content-center">{{ 'Is open?' | translate }}</div>
                        <div class="col-4 align-items-center justify-content-end">{{ 'Opening hours' | translate }}</div>
                        <div class="col-4 align-items-center justify-content-start">{{ 'Closing hours' | translate }}</div>
                    </div>
                </div>
                <div class="item" *ngFor="let day of days; let i = index;">
                    <div class="row">
                        <div class="col-3 align-items-center justify-content-start item-header">{{ day.day | translate }}</div>
                        <div class="col-1 align-items-center justify-content-center">
                            <em  class="fas {{
                                day.open
                                  ? 'fa-toggle-large-on toggle-primary'
                                  : 'fa-toggle-large-on fa-flip-horizontal toggle__icon inactive toggle-disabled'
                              }}" (click)="updateWorkingDay(day, i, true)" style="vertical-align: middle;"></em>
                        </div>
                        <div class="col-4 align-items-center justify-content-end">
                            <span *ngIf="day.open"><input type="time" (change)="updateWorkingDay(day, i);" class="form-control" id="dayAmStart_{{i}}" min="00:00" max="12:59" [(ngModel)]="day.am.start"></span>
                            <span *ngIf="!day.open"><input type="time" class="form-control" name="appt-time" disabled value=""></span>
                        </div>
                        <!--
                            <div class="col-2 align-items-center justify-content-start">
                                <span *ngIf="day.open"><input type="time" (change)="updateWorkingDay(day, i)" class="form-control" id="dayAmEnd_{{i}}" min="00:00" max="12:59" [(ngModel)]="day.am.end"></span>
                                <span *ngIf="!day.open"><input type="time" class="form-control" name="appt-time" disabled value=""></span>
                            </div>
                            <div class="col-2 align-items-center justify-content-end">
                                <span *ngIf="day.open"><input type="time" (change)="updateWorkingDay(day, i)" class="form-control" id="dayPmStart_{{i}}" min="13:00" max="23:59" [(ngModel)]="day.pm.start"></span>
                                <span *ngIf="!day.open"><input type="time" class="form-control" name="appt-time" disabled value=""></span>
                            </div>
                        -->
                        <div class="col-4 align-items-center justify-content-start">
                            <span *ngIf="day.open"><input type="time" (change)="updateWorkingDay(day, i)" class="form-control" id="dayPmEnd_{{i}}" min="13:00" max="23:59" [(ngModel)]="day.pm.end"></span>
                            <span *ngIf="!day.open"><input type="time" class="form-control" name="appt-time" disabled value=""></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="form-group">
    <div class="row">
        <div class="col">
            <label class="input-label">{{ 'Holidays' | translate }}</label>
            <div class="table-items">
                <div class="item item-header">
                    <div class="row">
                        <div class="col-3 align-items-center justify-content-start"></div>
                        <div class="col-4 align-items-center justify-content-center">{{ 'From' | translate }}</div>
                        <div class="col-4 align-items-center justify-content-center">{{ 'To' | translate }}</div>
                        <div class="col-1 align-items-center justify-content-start"></div>
                    </div>
                </div>
                <div class="item" *ngFor="let holiday of workingTimeProperties.holidays | sortBy:'asc':'fromDate'; let i = index;">
                    <div class="row">
                        <div class="col-3 align-items-center justify-content-start">{{holiday.name}}</div>
                        <div class="col-4 align-items-center justify-content-center">{{holiday.fromDate | date: 'dd-MM-yyyy'}}</div>
                        <div class="col-4 align-items-center justify-content-center">{{holiday.toDate | date: 'dd-MM-yyyy'}}</div>
                        <div class="col-1 align-items-center justify-content-end"><i (click)="deleteHoliday(i);" class="btn-bordered btn-danger btn-icon btn-xs fa-times false fas"></i></div>
                    </div>
                </div>
                <div class="item">
                    <div class="row">
                        <div class="col-3 align-items-center justify-content-start">
                            <input type="text" [(ngModel)]="newHoliday.name" name="name" required="" (change)="checkEndHolidayIsValid()" id="holidayName" class="form-control w-100" placeholder="Name">
                        </div>
                        <div class="col-4 align-items-center justify-content-center">
                            <input type="date" [(ngModel)]="newHoliday.fromDate" class="form-control" (change)="checkEndHolidayIsValid()" id="holidayStart" name="holiday-start" min="{{today | date: 'yyyy-MM-dd'}}" max="2048-12-31">
                        </div>
                        <div class="col-4 align-items-center justify-content-center">
                            <input type="date" [(ngModel)]="newHoliday.toDate" class="form-control" (change)="checkEndHolidayIsValid()" id="holidayEnd" min="{{newHoliday.fromDate}}" max="2048-12-31" name="holiday-end">
                        </div>
                        <div class="col-1 align-items-center justify-content-end"><button (click)="addHoliday();" id="submitHoliday" class="editBtn  btn-dark">{{ 'Add' | translate }}</button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
